import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import SettingsPage from './SettingsPage';
import BoardManagePage from './BoardManagePage';
import UserManagePage from './UserManagePage';
import MenuManagement from './MenuManagement';
import './AdminPage.css';

const AdminPage = () => {
  const { isAuthenticated, user } = useAuth();
  const [activeTab, setActiveTab] = useState('settings');

  // 관리자 권한 확인
  const isAdmin = user?.role === 'admin' || user?.role === 'moderator';

  // 관리자가 아닌 경우 접근 거부
  if (!isAuthenticated || !isAdmin) {
    return (
      <div className="admin-page">
        <div className="access-denied">
          <div className="access-denied-icon">🔒</div>
          <h2>접근 권한이 없습니다</h2>
          <p>관리자만 이 페이지에 접근할 수 있습니다.</p>
        </div>
      </div>
    );
  }

  const adminTabs = [
    { id: 'settings', label: '설정', icon: '⚙️' },
    { id: 'menus', label: '메뉴 관리', icon: '🎯' },
    { id: 'boards', label: '게시판 관리', icon: '📋' },
    { id: 'users', label: '유저 관리', icon: '👥' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'settings':
        return <SettingsPage />;
      case 'menus':
        return <MenuManagement />;
      case 'boards':
        return <BoardManagePage />;
      case 'users':
        return <UserManagePage />;
      default:
        return <SettingsPage />;
    }
  };

  return (
    <div className="admin-page">
      {/* 관리자 헤더 */}
      <div className="admin-header">
        <div className="admin-title">
          <span className="admin-icon">⚙️</span>
          <h1>관리자 페이지</h1>
        </div>
        <div className="admin-info">
          <span className="admin-role">
            {user?.role === 'admin' ? '👑 관리자' : '🛡️ 모더레이터'}
          </span>
        </div>
      </div>

      {/* 관리자 탭 네비게이션 */}
      <div className="admin-tabs">
        {adminTabs.map(tab => (
          <button
            key={tab.id}
            className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      {/* 탭 콘텐츠 */}
      <div className="admin-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default AdminPage;